// extracted by mini-css-extract-plugin
export default {"root":"mixes-list_root__MwrYQ","filler":"mixes-list_filler__fKzTK"};